<template>
  <div class="first-div">
    <div id="login-layout" >
      <el-row id="login_title" type="flex" justify="center">
        <img src="./assets/img/logo.png"  >
        <span class="fonts_center" >&nbsp;ERP管理系统登录页</span>
      </el-row>

      <div id="login-input">
        <!-- 用户名 -->
        <el-row type="flex" justify="center">
          <el-input v-bind:autofocus="true" placeholder="请输入用户名" v-model.trim="user.userName" @blur="$v.user.userName.$touch()" :class="{checkinput: $v.user.userName.$error}" clearable>
            <i slot="prefix" class="el-input__icon el-icon-user"/>
          </el-input>
        </el-row>
        <el-row class="warning-message"><div v-if="$v.user.userName.$error">用户名不能为空</div></el-row>
        <!-- 密码 -->
        <el-row type="flex" justify="center">
          <el-input type="password" placeholder="请输入密码" v-model="user.passWord" @keypress.enter.native="Loading" @keyup.native="createRsa" @blur="$v.user.passWord.$touch()" clearable>
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </el-row>
        <el-row class="warning-message"><div v-if="$v.user.passWord.$error" >密码不能为空</div></el-row>
        <!-- 验证码 -->
        <el-row  v-if="checkCodeDisplay">
          <el-row type="flex" justify="center">
            <el-input placeholder="验证码" v-model.trim ="user.checkCode" @blur="$v.user.checkCode.$touch()" clearable>
              <i slot="prefix" class="el-input__icon el-icon-message"></i>
            </el-input>     
            <div id="checkNumValueImg">
              <div v-if="checkCodeDisplay">
                <i v-if="$v.user.checkCode.$error" class="el-icon-success" style="color: green;font-size: 24px;"/>
                <i v-else class="el-icon-error" style="color: red;font-size: 24px;"/>
              </div>
            </div>     
            <!-- <img src="./assets/temp.png"> -->
          </el-row>
          <el-row class="warning-message"><div v-if="$v.user.checkCode.$error" >验证码不能为空</div></el-row>
        </el-row>
        <!-- 记住密码和忘记密码 -->
        <el-row type="flex" justify="start">
          <el-col><el-checkbox v-model="rememberMe" style="color: #b2b2b2;">记住账号密码</el-checkbox></el-col>
          <el-col style="text-align: right;vertical-align:middle;color: #b2b2b2;font-size:14px;padding-top:2px;">忘记密码?</el-col>
        </el-row>
        <!-- 登陆按钮 -->
        <el-row type="flex" justify="center" style="padding-top: 25px;">
          <el-button :disabled="$v.$invalid" id="login_button" type="primary" :loading="loadingType" @click="Loading" >登&nbsp;录</el-button>
        </el-row>
        
        
      </div>
    </div>

    <div id="footer">
        <div>技术支持：匠人图书ERP&nbsp;电话：010-88888888</div>
        <div>&copy;2019-2020 it1984.com 版权所有 <a href="http://www.beian.miit.gov.cn" target="view_window">吉ICP备18002277号</a></div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { login } from '@/api/login'
import { encrypt, decrypt } from '@/utils/rsaEncrypt'
import { Notification, MessageBox } from 'element-ui'
import { setUUID } from '@/utils/auth'
import Cookies from 'js-cookie'
import axios from 'axios'
import store from '@/store'
import Config from '@/config'
export default {
  name: 'Login',
  data () {
    return {
      user: {
        userName: '',
        passWord: '',
        rsaPassWord: '',
        checkCode: '',
        uuid: ''
      },      
      loadingType: false,
      checkCodeDisplay: false,
      rememberMe: false,
      rememberMeDay: 0,
      token: ''
    }
  },
  created() {
    this.getCookie()
  },
  methods: {
    Loading() {
      this.loadingType = true
      login(this.user).then(res => {
        const code = res.status.code       
        if(code == 200){
          this.token = res.data.token
          this.rememberMeDay = res.data.rememberMeDay
          Cookies.set(Config.TokenKey, this.token, 0)
          Cookies.set(Config.UserKey, res.data.user.userId, 0)
          if (this.rememberMe && this.rememberMeDay > 0) {
            Cookies.set('username', this.user.userName, { expires: this.rememberMeDay })
            Cookies.set('password', this.user.rsaPassWord, { expires: this.rememberMeDay })
            Cookies.set('rememberMe', this.rememberMe, { expires: this.rememberMeDay })
          } else {
            Cookies.remove('username')
            Cookies.remove('password')
            Cookies.remove('rememberMe')
          }
          store.commit('SET_TOKEN',this.token)
          //store.commit('SET_USER',res.data.user)
          store.commit('SET_REQUEST_TYPE',true)
          this.$router.push('/home')
        }else{
          this.loadingType = false
          if(code == 201){
            Notification.error({
              title: res.status.message,
              duration: 2500
            })            
          }
        }
      })
      .catch(error => {
        this.loadingType = false
        return Promise.reject('error')
      })
      
    },
    getCookie() {
      const userName = Cookies.get('username')
      const rsaPassWord = Cookies.get('password')
      const rememberMe = Cookies.get('rememberMe')

      // 保存cookie里面的加密后的密码
      this.user.rsaPassWord = rsaPassWord === undefined ? '' : rsaPassWord
      this.user.passWord = rsaPassWord === undefined ? '' : 'password'      
      this.user.userName = userName === undefined ? '' : userName
      this.rememberMe = rememberMe === undefined ? false : true
    },
    createRsa() {
      this.user.rsaPassWord = encrypt(this.user.passWord)
    }
  },
  //输入校验
  validations() {
    if (!this.checkCodeDisplay){
      return {
        user: {
          userName: {
            required
          },
          passWord: {
            required
          }
        }
      }
    } else {
      return {
        user: {
          userName: {
            required
          },
          passWord: {
            required
          },
          checkCode: {
            required
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .first-div {
    height: 100%;
    background-image:url(	'./assets/img/background.png' );
    background-size:100% 100%;
    display: flex;
    align-items: center;
  }
  #login-layout{
    background:#ffffff;
    width: 462px;
    //height: 444px;
    border-radius: 4px;
    //position: absolute;
    top: 0;
    bottom: 0;
    //left: 51%;
    margin-left: 63%;
    right: 0;
    //margin: auto;
  }
  #login_title{
    padding-top:55px;
    padding-bottom:55px;
    font-size:28px;
    color:#332c2b;
  }
  #login-input{
    padding-left: 55px;
    padding-right: 55px;
    padding-bottom:55px;
  }

  #checkNumValueImg {
    width: 63px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;  
  }
  #login_button{
    color:#ffffff;
    background:#fe6522;
    border: 0px;
    width: 100%;
  }
  #login_button:hover{
    filter: alpha(Opacity=80);
    opacity: 0.8;
  }
  #footer {
      height: 50px;
      line-height: 15px;
      position: fixed;
      bottom: 0;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 12px;
      letter-spacing: 1px;
      padding-bottom:20px;
  }
  .checkinput {    
    border-color: red;
  }

// 备案信息样式
a{
  color: #fff;
    text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none;
}
/* 正在点击的链接*/
a:active {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/Login.vue